export default __webpack_public_path__ + "static/media/file upload icon.f8f16378.svg";